(() => {
	function initializeContact(root = document) {
		const params = new URLSearchParams(window.location.search);
		root.querySelectorAll('.tb-contact__form').forEach((form) => {
			if (form.dataset.initialized) return;
			form.dataset.initialized = 'true';
			const topic = form.querySelector('[data-contact-topic]');
			if (topic && ['product_advice', 'integration', 'software', 'support', 'other'].includes(params.get('topic'))) topic.value = params.get('topic');
			if (params.get('setup') === 'builder') {
				try {
					const setup = JSON.parse(sessionStorage.getItem('testblox-system-setup') || 'null');
					const body = form.querySelector('textarea[name="contact[body]"]');
					if (body && !body.value && typeof setup?.message === 'string' && Date.now() - setup.createdAt < 86400000) body.value = setup.message.slice(0, 10000);
				} catch (_) { /* Normal contact form remains available without stored setup. */ }
			}
			const product = form.querySelector('[data-contact-product]');
			if (product) {
				if (!product.value) product.value = (params.get('product') || '').slice(0, 500);
				form.querySelector('[data-contact-context]').hidden = !product.value;
				const path = params.get('product_url') || '';
				if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+(?:\?variant=\d+)?$/i.test(path)) form.querySelector('[data-contact-product-url]').value = path;
			}
			form.querySelector('[data-contact-status]')?.focus();
		});
	}
	initializeContact();
	document.addEventListener('shopify:section:load', (event) => initializeContact(event.target));
})();
